import {ISlidePreview} from '../../incase-domain/proptypes/slidePreview';
import {
    IClearSlidePreviewPendingAction,
    IFetchPresentationSlidePreviewsAction,
    IHideLoadingSpinnerAction,
    IMarkSlidePreviewPendingAction,
    IMarkSlidePreviewsPendingAction,
    IShowLoadingSpinnerAction,
    IUpdateSelectedSlidePreviewsAction,
} from './types/slide.preview.types';

export const UPDATE_SELECTED_SLIDE_PREVIEWS = 'UPDATE_SELECTED_SLIDE_PREVIEWS';
export const SHOW_LOADING_SPINNER = 'SHOW_LOADING_SPINNER';
export const HIDE_LOADING_SPINNER = 'HIDE_LOADING_SPINNER';
export const MARK_SLIDE_PREVIEW_PENDING = 'MARK_SLIDE_PREVIEW_PENDING';
export const MARK_SLIDE_PREVIEWS_PENDING = 'MARK_SLIDE_PREVIEWS_PENDING';
export const CLEAR_SLIDE_PREVIEW_PENDING = 'CLEAR_SLIDE_PREVIEW_PENDING';
export const FETCH_PRESENTATION_SLIDE_PREVIEWS = 'FETCH_PRESENTATION_SLIDE_PREVIEWS';

export const updateSelectedSlidePreviewsAction = (slidePreviews: ISlidePreview[]): IUpdateSelectedSlidePreviewsAction => ({
    type: UPDATE_SELECTED_SLIDE_PREVIEWS,
    payload: slidePreviews,
});

export const showLoadingSpinnerAction = (): IShowLoadingSpinnerAction => ({
    type: SHOW_LOADING_SPINNER,
});

export const hideLoadingSpinnerAction = (): IHideLoadingSpinnerAction => ({
    type: HIDE_LOADING_SPINNER,
});

export const markSlidePreviewPendingAction = (slideId: string): IMarkSlidePreviewPendingAction => ({
    type: MARK_SLIDE_PREVIEW_PENDING,
    slideId,
});

export const markSlidePreviewsPendingAction = (slideIds: string[]): IMarkSlidePreviewsPendingAction => ({
    type: MARK_SLIDE_PREVIEWS_PENDING,
    slideIds,
});

export const clearSlidePreviewPendingAction = (slideId: string): IClearSlidePreviewPendingAction => ({
    type: CLEAR_SLIDE_PREVIEW_PENDING,
    slideId,
});

export const fetchPresentationSlidePreviewsAction = (): IFetchPresentationSlidePreviewsAction => ({
    type: FETCH_PRESENTATION_SLIDE_PREVIEWS,
});
